export enum RealTimeDataTypes {
  NetworkUpdated = "NetworkUpdated"
}
